export default function deleteIdOfLiaisonsTarif(produit) {
  if (produit.liaisonsTarif.length === 0) { return; }

  produit.liaisonsTarif.forEach((liaison) => {
    delete liaison.id;
    if (liaison.liaisonsTarif) {
      liaison.liaisonsTarif.forEach((liaisonTarifEnfant) => {
        delete liaisonTarifEnfant.id;
      });
    }
  });
}
